import { render, staticRenderFns } from "./CardMensageria.vue?vue&type=template&id=17dcecd4&scoped=true"
import script from "./CardMensageria.vue?vue&type=script&lang=js"
export * from "./CardMensageria.vue?vue&type=script&lang=js"
import style0 from "./CardMensageria.vue?vue&type=style&index=0&id=17dcecd4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17dcecd4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17dcecd4')) {
      api.createRecord('17dcecd4', component.options)
    } else {
      api.reload('17dcecd4', component.options)
    }
    module.hot.accept("./CardMensageria.vue?vue&type=template&id=17dcecd4&scoped=true", function () {
      api.rerender('17dcecd4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CardMensageria.vue"
export default component.exports